import { get, map } from 'lodash';

import Model from 'models';

const CategoryCarouselModel = class extends Model {
  get type() {
    return get(this._data, '_contentType');
  }

  get title() {
    return get(this._data, 'carouselName');
  }

  get categories() {
    const categories = get(this._data, 'categories');

    return map(categories, category => {
      const categoryCards = get(category, 'categoryCards');
      return {
        categoryName: get(category, 'categoryName'),
        categoryCards: map(categoryCards, card => ({
          productName: get(card, 'carouselCardName'),
          tagline: get(card, 'carouselCardTagline'),
          taglineIcon: {
            src: get(card, ['carouselCardTaglineIcon', 'file', 'url']),
            alt: get(card, ['carouselCardTaglineIcon', 'description']),
          },
          ctaLinks: get(card, 'ctaLinks'),
          image: {
            src: get(card, ['image', 'file', 'url']),
            alt: get(card, ['image', 'description']),
          },
        })),
      };
    });
  }
};

export default CategoryCarouselModel;
